<template>
  <div class="container" style="padding-bottom:30px">
    <img class="bg-img" src="~@static/ugc/list/bg.jpg">
    <div class="upload-wrapper" v-if="pictures.length == 0">
      <div class="form-inner">
        <div class="form-input">
          <vue-core-image-upload :class="['file-btn1']" :crop="false" @imageuploaded="imageuploaded"
            @imageuploading="imageuploading" inputOfFile="file" text="" :max-file-size="5242880" :compress="30"
            :max-width="200" input-accept="image/*" :url="uploadUrl">
          </vue-core-image-upload>
        </div>
      </div>
      <img class="msg" src="~@static/ugc/creation/text-add.png">
    </div>
    <!--  -->

    <div class="upload-imgs-list" v-if="pictures.length > 0">
      <div v-for="(item, index) in pictures" :key="index" class="upload-img-item"
        style="background-image:url(~@static/ugc/creation/border.png)">
        <div class="upload-img-wrapper">
          <div class="upload-img-inner">
            <template v-if="item.filter==0">
              <img class="cover-img" :src="hostUrl + item.img">
            </template>
            <template v-else>
              <img class="cover-img" :src="hostUrl + item.img">
              <img :src="require(`@static/ugc/creation/filter/mask-${item.filter[0]}.png`)" class="filter-mask">
              <img :src="require(`@static/ugc/creation/filter/top-${item.filter[0]}.png`)" class="filter-top">
              <img :src="require(`@static/ugc/creation/filter/bottom-${item.filter[0]}.png`)" class="filter-bottom">
            </template>
          </div>
        </div>
        <img class="close-btn" src="~@static/ugc/creation/icon-close.png" :data-src="item"
          @click="delPhoto($event, index)">
      </div>
      <div class="form-inner" v-if="pictures.length<5">
        <div class="form-input">
          <vue-core-image-upload :class="['file-btn2']" :crop="false" @imageuploaded="imageuploaded"
            @imageuploading="imageuploading" inputOfFile="file" text="" :max-file-size="5242880" :compress="30"
            :max-width="200" input-accept="image/*" :url="uploadUrl">
          </vue-core-image-upload>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="form-group">
      <input class="form-control text-center placeholder-style" placeholder="输入我的标题" v-model="title" maxlength="50"
        @change="bindTitleChange" />
    </div>
    <div class="form-group">
      <textarea placeholder="写更多的文字告诉大家我的想法" class="placeholder-style" v-model="description"
        @change="bindDescriptionChange" maxlength="1000" />
    </div>
    <div class="btn-choose" :class="event_name.length?'active':''" @click="bindToFilter">
      <template v-if="event_name.length == 0">选择夜计划</template>
      <template v-else>{{event_name}}</template>
      <img class="icon" src="~@static/ugc/creation/icon-arrow.png">
    </div>
    <div class="pink-circle-btn with-icon" :class="active?'active':''" @click="bindToPublish">
      <div class="btn-inner">
        <div class="text">发布</div>
        <img src="~@static/icon-pink-circle-btn.png">
      </div>
    </div>
    <!-- pop -->
    <div class="mask" v-if="isFilter" @click="isFilter=false"></div>
    <div class="pop-filter" v-show="isFilter">
      <div class="pop-title">请选择要查找的夜计划</div>
      <div class="pop-wrapper">
        <div class="pop-content">
          <div :class="[{'cur':event_id==item.id, 'charter': item.first}]" @click.stop="bindToChangeFilter"
            :data-id="item.id" :data-name="item.name" v-for="(item, index) in plans" :key="index">{{item.name}}</div>
        </div>
      </div>
      <div class="letterList">
        <div v-for="(item,index) in letters" @click="filterPlanByLetter" :data-index="index" :data-letter="item"
          :class="item === curLetter?'cur':''" :key="index">{{item}}</div>
      </div>
    </div>
    <div class="pop-success" v-if="isConfirm">
      <div class="pop-inner">
        <img src="~@static/ugc/creation/pop-text.png" class="txt">
        <div class="btn-submit" @click="bindToConfirm">知道啦</div>
      </div>
    </div>

    <!-- 贴纸 -->
    <div class="filter-page" v-if="isShowFilter">
      <div class="banner-area">
        <div class="banner-list">
          <template v-if="tempImg.filter==0">
            <img :src="`${hostUrl}${tempImg.img}`" class="cover-img">
          </template>
          <template v-else>
            <img :src="`${hostUrl}${tempImg.img}`" class="cover-img">
            <img :src="require(`@static/ugc/creation/filter/mask-${tempImg.filter[0]}.png`)" class="filter-mask">
            <img :src="require(`@static/ugc/creation/filter/top-${tempImg.filter[0]}.png`)" class="filter-top">
            <img :src="require(`@static/ugc/creation/filter/bottom-${tempImg.filter[0]}.png`)" class="filter-bottom">
          </template>
        </div>
      </div>
      <div class="pop-bottom pop-filterOptions">
        <div class="btns">
          <img class="btn" src="~@static/fundingnew/profile/btn-cancel.png" @click="closeFilter">
          <img class="btn" src="~@static/fundingnew/profile/btn-confirm.png" @click="bindFilterConfirm">
        </div>
        <div class="pop-title">请选择原图或添加滤镜</div>
        <div class="options">
          <div @click="bindToSelectFilter" data-filter="0">
            <img class="icon" src="~@static/ugc/creation/filter/option-1.png" v-if="tempImg.filter != 0">
            <img class="icon" src="~@static/ugc/creation/filter/option-1-selected.png" v-else>
            <span class="txt">原图</span>
          </div>
          <div @click="bindToSelectFilter" data-filter="2">
            <img class="icon" src="~@static/ugc/creation/filter/option-3.png" v-if="tempImg.filter != 2">
            <img class="icon" src="~@static/ugc/creation/filter/option-3-selected.png" v-else>
            <span class="txt">绝对赛博</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageFooter from '@components/PageFooter'
import RebuildNavBar from '@components/RebuildNavBar'
import VueCoreImageUpload from 'vue-core-image-upload'
import { mapMutations, mapState } from 'vuex'
import { behavior } from '@/utils/behavior'
export default {
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      domainUrl: this.$apiConfig.domain,
      uploadUrl: this.$apiConfig.uploadUrl,
      pictures: [],
      title: '',
      description: '',
      isFilter: false,
      event_name: '',
      event_id: '',
      active: false,
      isConfirm: false,
      canSubmit: true,
      plans: [],
      // 贴纸
      isShowFilter: false,
      tempImg: {
        img: '',
        filter: false,
      },
      letters: [],
      curLetter: '', //当前筛选的字母
      letterId: '', //scrollview定位用的字母id
      lettersTop: '', //anchor在页面里的top位置
      scrollViewTop: '', //scroll-view在页面里的top位置
      scrollInnerTop: 0, //scroll-view 内滚动位置
      // 首字母位置
      pos: [],
    }
  },
  components: {
    PageFooter,
    RebuildNavBar,
    VueCoreImageUpload,
  },
  computed: {
    ...mapState(['rebuildCreate', 'authorization', 'showLoading']),
  },
  created() {
    let letter = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('')
    this.letters = letter
    this.requestPlans()
  },
  mounted() {},
  methods: {
    ...mapMutations(['setRebuildCreate', 'removeRebuildCreate', 'setShowLoading']),
    imageuploaded(res) {
      if (this.pictures.length >= 5) {
        alert('最多可上传5张图片')
        return false
      }
      if (res.code == 0) {
        _jcq.push(['_track', 'ugc_photoupload'])
        behavior({ behavior_code: 'prc_bhv_abs_pw_bc9' })
        this.pictures.push({
          img: res.data.base,
          filter: false,
        })
        this.isShowFilter = true
        this.tempImg.img = res.data.base
        this.tempImg.filter = false
        this.setShowLoading(false)
      } else {
        alert('上传失败')
        this.setShowLoading(false)
      }
    },
    imageuploading(res) {
      this.setShowLoading(true)
    },
    delPhoto(e, index) {
      let delConfirm = confirm('确定要删除此图片？')
      if (delConfirm) {
        this.pictures.splice(index, 1)
        this.checkActive()
      }
    },
    requestPlans: function () {
      const _self = this
      this.$request
        .get(this.$apiConfig.ugcPlanUrl)
        .then(res => {
          const resData = res.data
          if (resData.code === 0) {
            const _resData = resData.data
            // 空字母
            let arr1 = []
            // 含字母
            let arr2 = []
            let arr_charter = new Set()
            let hasCharter = new Set()
            _resData.forEach((item, index) => {
              if (!hasCharter.has(item.first_charter)) {
                item.first = true
              }
              if (item.first_charter === '') {
                item.first_charter = '#'
                arr1.push(item)
              } else {
                arr2.push(item)
              }
              hasCharter.add(item.first_charter)
            })
            arr2.sort((a, b) => (a.first_charter < b.first_charter ? -1 : a.first_charter > b.first_charter ? 1 : 0))
            let arr3 = [...arr2, ...arr1]
            arr3.forEach(item => {
              arr_charter.add(item.first_charter)
            })
            let tmpArr = []
            this.letters = [...arr_charter]
            this.plans = arr3
            this.pos = []
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    filterPlanByLetter: function (e) {
      let _this = this
      let letter = e.target.dataset.letter
      let index = parseInt(e.target.dataset.index)
      this.curLetter = letter
      let $box = document.querySelector('.pop-wrapper')
      $box.scrollTop = this.pos[index]
      console.log(this.pos[index])
    },
    bindToFilter() {
      this.isFilter = !this.isFilter
      this.$nextTick(() => {
        let $el = document.querySelectorAll('.charter')
        let arr_pos = []
        $el.forEach($item => {
          arr_pos.push($item.offsetTop - 5)
        })
        this.pos = arr_pos
      })
      let $box = document.querySelector('.pop-wrapper')
      let _that = this
      function fn() {
        let t = $box.scrollTop
        let i = _that.pos.findIndex(item => {
          return item > t
        })
        _that.curLetter = _that.letters[i - 1]
      }
      if (this.isFilter) {
        $box.addEventListener('scroll', fn)
      } else {
        $box.removeEventListener('scroll', fn)
      }
    },

    checkActive() {
      if (this.pictures.length && this.title.length && this.description.length && this.event_name.length) {
        this.active = true
      } else {
        this.active = false
      }
    },
    bindTitleChange() {
      this.checkActive()
    },
    bindDescriptionChange() {
      this.checkActive()
    },
    bindToChangeFilter(e) {
      this.event_id = e.target.dataset.id
      this.event_name = e.target.dataset.name
      this.isFilter = false
      this.checkActive()
    },

    bindToPublish() {
      const _self = this
      if (this.pictures.length == 0) {
        alert('请上传1到5张活动照片')
        return
      }
      if (this.title.length == 0) {
        alert('请输入标题')
        return
      }
      if (this.description.length == 0) {
        alert('请输入介绍')
        return
      }
      if (this.event_name.length == 0) {
        alert('请选择一个夜计划')
        return
      }
      if (!this.active) return
      if (!this.canSubmit) return
      this.canSubmit = false
      // 滤镜图片上传加工
      let filter_id = ''
      let imgs = []
      this.pictures.forEach((item, idx) => {
        filter_id += item.filter + ','
        imgs.push(item.img)
      })
      if (filter_id.length > 0) {
        filter_id = filter_id.substring(0, filter_id.length - 1)
      }
      this.$request
        .post(this.$apiConfig.ugcUrl, {
          plan_id: this.event_id,
          title: this.title,
          description: this.description,
          picture: imgs,
          filter_id: filter_id,
        })
        .then(res => {
          _jcq.push(['_track', 'ugc_photopublish'])
          behavior({ behavior_code: 'prc_bhv_abs_pw_bc10' })
          let _resData = res.data

          if (_resData.code == 0) {
            this.isConfirm = true
            this.canSubmit = true
          } else {
            alert('提交失败，请重新提交')
          }
        })
        .catch(e => {})
    },

    bindToConfirm() {
      this.isConfirm = false
      this.$router.push('/scene/list')
    },

    closeFilter() {
      this.tempImg = { img: '', filter: false }
      this.isShowFilter = false
    },
    bindFilterConfirm() {
      let n = this.pictures.length
      this.$set(this.pictures[n - 1], 'filter', this.tempImg.filter)
      this.closeFilter()
      _jcq.push(['_track', 'ugcfilter_confirm'])
      behavior({ behavior_code: 'prc_bhv_abs_ugc_bc4' })
    },
    bindToSelectFilter(e) {
      this.tempImg.filter = e.currentTarget.dataset.filter
      if(e.currentTarget.dataset.filter == 0) {
        _jcq.push(['_track', 'ugcfilter1_choose'])
        behavior({ behavior_code: 'prc_bhv_abs_ugc_bc2' })
      } else {
        _jcq.push(['_track', 'ugcfilter2_choose'])
        behavior({ behavior_code: 'prc_bhv_abs_ugc_bc3' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/ugc/create.scss';
</style>



// WEBPACK FOOTER //
// src/pages/ugc/create.vue